import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

type ModalColorVariant = 'primary' | 'white';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styles: [`
    :host ::ng-deep .no-close-icon .p-dialog-header-close {
      display: none !important;
    }
  `]
})
export class ModalComponent implements OnChanges {
  @Input() open: boolean = false;
  @Input() title: string = '';
  @Input() style: any = {
    width: '40vw',
  };
  @Input() breakpoints: any = { '1200px': '90vw' };
  @Input() cancelButtonLabel: string = 'Cancel';
  @Input() confirmButtonLabel: string = 'Confirm';
  @Input() variant: ModalColorVariant = 'white';
  @Input() showFooter:boolean = false;
  @Input() haveCancellation: boolean = true;
  @Input() alignStart: boolean =false;
  @Input() buttonAlignment: string = '';
  @Input() className: string = '';
  @Input() dismissableMask: boolean = true;
  @Input() showCloseIcon: boolean = true;
  @Input() saving: boolean = false;

  @Output() onCancel = new EventEmitter();
  @Output() onConfirm = new EventEmitter();
  @Output() onClose = new EventEmitter();

  private setHeaderColor(variant: ModalColorVariant): void {
    if (typeof document !== 'undefined') {
      const headerEl = document.getElementsByClassName('p-dialog-header')?.[0];
      if (headerEl) {
        headerEl.classList.add(variant === 'primary' ? 'bg-primary' : 'bg-white');
      }
    }
  }

  ngOnInit() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
    }
  }

  ngOnDestroy() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      setTimeout(() => this.setHeaderColor(this.variant));
    }
  }

  handleClose(event: MouseEvent) {
    this.onClose.emit(false);
  }

  onCancelClick(event: MouseEvent) {
    this.onCancel.emit(event);
  }

  onConfirmationClick(event: MouseEvent) {
    this.onConfirm.emit(event);
  }

  onDialogHide(){
    this.open =false;
    this.onClose.emit(false);
  }
}
